import { Editor } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export function nodes(editor: Editor, options?: WithQueryOptions<typeof Editor.nodes, 1>) {
    return Editor.nodes(editor, getQueryOptions(editor, options));
}
